import { useContext, useEffect } from 'react';
import { Redirect } from 'react-router';

import { VehicleLookupContext } from 'Context/vehicleLookup';

import { INCODE_ANALYTICS } from '../../../../documentCapture/uploadDocuments/pages/IncodeSDKPage/IncodeAnalytics';
import { PROFILING_PATH } from '../../../VehicleProfiling.constants';

const { PROFILE, TIMELINE } = PROFILING_PATH;

export const TimelineEarlyDocsIncodeComplete = () => {
  const { vehicleLookupState: vehicle } = useContext(VehicleLookupContext);

  useEffect(() => {
    INCODE_ANALYTICS.INCODE_SECTION_LOADED('early_docs_complete_redirecting');
  }, []);

  return <Redirect to={`/${vehicle.vrm}${PROFILE}${TIMELINE}`} />;
};
